<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        Brisage
      </div>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <Brisage/>
    </v-main>
  </v-app>
</template>

<script>
import Brisage from './components/Brisage';

export default {
  name: 'App',

  components: {
    Brisage,
  },

  data: () => ({
    //
  }),
};
</script>
